import { HelpfulLink as HelpfulLinkDto } from '@electricjs/core_entity-client';

export const buildMockHelpfulLinks = (): HelpfulLinkDto[] => [
  {
    link_id: 'helpful-link-1',
    link_url: 'https://simple-org.com/handbook',
    title: 'Employee handbook',
    description: 'Policies, benefits and everything about working here.',
  },
  {
    link_id: 'helpful-link-2',
    link_url: 'https://simple-org.com/it-faq',
    title: 'IT FAQ',
    description: 'Answers to the most common IT questions.',
  },
];
